/**
 * Shared Type Definitions
 */

export * from "./bm";
export * from "./bm-diagrams";
export * from "./feature";
export * from "./mapping";
export type * from "./pipeline";
export type * from "./stage";
export * from "./source-explorer";
export * from "./datamart";
export * from "./validation";
export type * from "./auth";
export {
  PERMISSION_PROJECT_EDIT,
  PERMISSION_SOURCE_DELETE,
  PERMISSION_NOTES_VIEW,
  PERMISSION_NOTES_EDIT,
  PERMISSION_DICTIONARIES_MANAGE,
  PERMISSION_BM_VIEW,
  PERMISSION_BM_EDIT,
  PERMISSION_MAPPING_VIEW,
  PERMISSION_MAPPING_EDIT,
  PERMISSION_FEATURE_VIEW,
  PERMISSION_FEATURE_EDIT,
} from "./auth";

// Legacy types (for counter demo)
export interface IAppConfig {
  readonly name: string;
  readonly version: string;
  readonly isDev: boolean;
}

export type TStoreAction = "increment" | "decrement" | "reset";

export const enum EEnvironment {
  DEVELOPMENT = "development",
  PRODUCTION = "production",
  TEST = "test",
}
